module.exports = __webpack_public_path__ + "img/Patch6.1.359fea91.webp";